import translate from "./../../services/translation.json";
import "./ourClients.scss";
import edelwealthLogo from "./../../assets/images/edelwealth.png";
import wohnLogo from "./../../assets/images/wohn.png";
import barberLogo from "./../../assets/images/barber.png";
import sfpgLogo from "./../../assets/images/sfpg.png";
import tarrafLogo from "./../../assets/images/tarraf.png";
import spazioLogo from "./../../assets/images/spazio.png";
import auditLogo from "./../../assets/images/audit.png";
import mezzeLogo from "./../../assets/images/mezze.png";
import blossomBloomLogo from "./../../assets/images/blossom-bloom.png";
import ahAutohandelLogo from "./../../assets/images/ah-autohandel.svg";
import multilineaLogo from "./../../assets/images/multilinea.svg";
// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const clientLogos = [
  { src: edelwealthLogo, alt: "Edelwealth" },
  { src: wohnLogo, alt: "Wohn" },
  { src: barberLogo, alt: "Barber" },
  { src: sfpgLogo, alt: "SFPG" },
  { src: tarrafLogo, alt: "Tarraf" },
  { src: spazioLogo, alt: "Spazio" },
  { src: auditLogo, alt: "Audit" },
  { src: mezzeLogo, alt: "Mezze" },
  { src: blossomBloomLogo, alt: "BlossomBloom" },
  { src: ahAutohandelLogo, alt: "AHAutohandel" },
  { src: multilineaLogo, alt: "MultiLinea" },
  { src: edelwealthLogo, alt: "Edelwealth" },
  { src: wohnLogo, alt: "Wohn" },
  { src: barberLogo, alt: "Barber" },
  { src: sfpgLogo, alt: "SFPG" },
  { src: tarrafLogo, alt: "Tarraf" },
  { src: spazioLogo, alt: "Spazio" },
  { src: auditLogo, alt: "Audit" },
  { src: mezzeLogo, alt: "Mezze" },
  { src: blossomBloomLogo, alt: "BlossomBloom" },
  { src: ahAutohandelLogo, alt: "AHAutohandel" },
  { src: multilineaLogo, alt: "MultiLinea" },
];

const OurClients = ({ lang }) => {
  return (
    <div className="our-clients">
      <h1>{translate[lang].homepage.our_clients}</h1>
      <div className="our-clients-logos">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={5}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 20 },
            900: { slidesPerView: 3, spaceBetween: 30 },
            1200: { slidesPerView: 5, spaceBetween: 30 },
          }}
          className="our-clients-swiper"
        >
          {clientLogos.map((logo, idx) => (
            <SwiperSlide key={idx}>
              <div className="logo-container">
                <img src={logo.src} alt={logo.alt} className={logo.alt.toLocaleLowerCase()} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default OurClients;
